/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Billingservicev1Checks } from '../models/Billingservicev1Checks';
import { Billingservicev1HealthCondition } from '../models/Billingservicev1HealthCondition';
import { HttpFile } from '../http/http';

export class Billingservicev1HealthCheck {
    'serviceName'?: string;
    'healthCondition'?: Billingservicev1HealthCondition;
    'commitHash'?: string;
    'serviceVersion'?: string;
    'checks'?: Billingservicev1Checks;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "healthCondition",
            "baseName": "healthCondition",
            "type": "Billingservicev1HealthCondition",
            "format": ""
        },
        {
            "name": "commitHash",
            "baseName": "commitHash",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceVersion",
            "baseName": "serviceVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "checks",
            "baseName": "checks",
            "type": "Billingservicev1Checks",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Billingservicev1HealthCheck.attributeTypeMap;
    }

    public constructor() {
    }
}

